import React, { useState } from 'react';
import FlashcardCategory from './FlashcardCategory';
import { Modal } from '../../KnowledgeBase/Modal';
import { orbData } from '../../KnowledgeBase/OrbField';
import styles from './Flashcard.module.css';

const Flashcard = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalAnimation, setModalAnimation] = useState(false);

  // Categorize orb data
  const categories = {
    Frontend: orbData.filter(orb => 
      ['React', 'HTML', 'CSS', 'JavaScript', 'TypeScript', 'Redux', 'CSS Frameworks']
      .includes(orb.title)
    ),
    Backend: orbData.filter(orb => 
      ['Node.js', 'Express.js', 'MongoDB', 'PostgreSQL', 'GraphQL']
      .includes(orb.title)
    ),
    Tools: orbData.filter(orb => 
      ['Git', 'Docker', 'VS Code', 'Terminal', 'Webpack']
      .includes(orb.title)
    ),
    Technologies: orbData.filter(orb => 
      ['REST APIs', 'Authentication', 'Testing', 'CI/CD', 'AWS']
      .includes(orb.title)
    )
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setModalAnimation(true);
  };

  return (
    <div className={styles.flashcardContainer}>
      {Object.entries(categories).map(([category, items]) => (
        <FlashcardCategory
          key={category}
          category={category}
          items={items}
          onItemClick={handleItemClick}
        />
      ))}

      {selectedItem && (
        <Modal
          isOpen={!!selectedItem}
          onClose={() => setSelectedItem(null)}
          content={selectedItem}
          animation={modalAnimation}
        />
      )}
    </div>
  );
};

export default Flashcard;
